const commaingNumber = (number) => {
  if (typeof number !== 'number' || number === 0) return 0;

  number = Math.round(number);
  let arr = [...String(number)];
  let length = arr.length;
  if (length > 3) {
    arr.splice(length - 3, 0, ',');
    let i = length - 3;
    while (i - 2 > 0) {
      i -= 2;
      arr.splice(i, 0, ',');
    }
  }
  return arr.join('');
};

export default commaingNumber;
